import React, { useEffect, useState } from "react";
import useHttp from '../../../../hook/use-http';
import { Chart } from 'react-google-charts';
import NoData from '../../../../componets/Dashboard/Driveanalysis/NoData';
import ChartLoader from '../../../../componets/Dashboard/Driveanalysis/ChartLoader';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import WaterMark from "../../../../componets/Dashboard/DashboardMain/WaterMark";


function NetEnergyBar({ apiend, gloablfilter }) {
  const [chartdata, setChartData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [fieldname, SetFieldName] = useState();
  const appyData = (data) => {
    const res_result = data;
    let responce = {
      "<1.3": { per: 0, count: 0 },
      "1.4": { per: 0, count: 0 },
      "1.5": { per: 0, count: 0 },
      "1.6": { per: 0, count: 0 },
      "1.7": { per: 0, count: 0 },
      "1.8": { per: 0, count: 0 },
      "1.9": { per: 0, count: 0 },
      "2": { per: 0, count: 0 },
      ">2": { per: 0, count: 0 }
    };
    if (res_result.length != 0) {

      let t_val = res_result[0];

      if (t_val.doc_count != 0) {
        if (t_val.less_13.value > 0) {
          responce["<1.3"] = { per: parseInt((t_val.less_13.value / t_val.doc_count) * 100), count: parseInt(t_val.less_13.value) };
        }
        if (t_val.B13_14.value > 0) {
          responce["1.4"] = { per: parseInt((t_val.B13_14.value / t_val.doc_count) * 100), count: parseInt(t_val.B13_14.value) };
        }
        if (t_val.B14_15.value > 0) {
          responce["1.5"] = { per: parseInt((t_val.B14_15.value / t_val.doc_count) * 100), count: parseInt(t_val.B14_15.value) };
        }
        if (t_val.B15_16.value > 0) {
          responce["1.6"] = { per: parseInt((t_val.B15_16.value / t_val.doc_count) * 100), count: parseInt(t_val.B15_16.value) };
        }
        if (t_val.B16_17.value > 0) {
          responce["1.7"] = { per: parseInt((t_val.B16_17.value / t_val.doc_count) * 100), count: parseInt(t_val.B16_17.value) };
        }
        if (t_val.B17_18.value > 0) {
          responce["1.8"] = { per: parseInt((t_val.B17_18.value / t_val.doc_count) * 100), count: parseInt(t_val.B17_18.value) };
        }
        if (t_val.B18_19.value > 0) {
          responce["1.9"] = { per: parseInt((t_val.B18_19.value / t_val.doc_count) * 100), count: parseInt(t_val.B18_19.value) };
        }
        if (t_val.B19_20.value > 0) {
          responce["2"] = { per: parseInt((t_val.B19_20.value / t_val.doc_count) * 100), count: parseInt(t_val.B19_20.value) };
        }
        if (t_val.greater_20.value > 0) {
          responce[">2"] = { per: parseInt((t_val.greater_20.value / t_val.doc_count) * 100), count: parseInt(t_val.greater_20.value) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]

        let loop_keys = Object.keys(responce);
        loop_keys = ["<1.3", "1.4", "1.5", "1.6", "1.7", "1.8", "1.9", "2", ">2"]
        loop_keys.map(x => {
          // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "#83A4CF"]);
          res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;"]);
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }
  const appyDatakwh = (data) => {
    const res_result = data;
    let responce = {
      "<100": { per: 0, count: 0 },
      "150": { per: 0, count: 0 },
      "200": { per: 0, count: 0 },
      "250": { per: 0, count: 0 },
      "300": { per: 0, count: 0 },
      ">300": { per: 0, count: 0 }
    };
    if (res_result.length != 0) {

      let t_val = res_result[0];

      if (t_val.doc_count != 0) {
        if (t_val.less_100.value > 0) {
          responce["<100"] = { per: parseInt((t_val.less_100.value / t_val.doc_count) * 100), count: parseInt(t_val.less_100.value) };
        }
        if (t_val.B100_150.value > 0) {
          responce["150"] = { per: parseInt((t_val.B100_150.value / t_val.doc_count) * 100), count: parseInt(t_val.B100_150.value) };
        }
        if (t_val.B150_200.value > 0) {
          responce["200"] = { per: parseInt((t_val.B150_200.value / t_val.doc_count) * 100), count: parseInt(t_val.B150_200.value) };
        }
        if (t_val.B200_250.value > 0) {
          responce["250"] = { per: parseInt((t_val.B200_250.value / t_val.doc_count) * 100), count: parseInt(t_val.B200_250.value) };
        }
        if (t_val.B250_300.value > 0) {
          responce["300"] = { per: parseInt((t_val.B250_300.value / t_val.doc_count) * 100), count: parseInt(t_val.B250_300.value) };
        }
        if (t_val.B300_350.value > 0) {
          responce[">300"] = { per: parseInt((t_val.B300_350.value / t_val.doc_count) * 100), count: parseInt(t_val.B300_350.value) };
        }

        let res_result_final = [["Element", "percent", { type: 'string', role: "tooltip", 'p': { 'html': true } }, { role: "style" }]]
        let loop_keys = Object.keys(responce);
        loop_keys = ["<100", "150", "200", "250", "300", ">300"]
        loop_keys.map(x => {
          // res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "#83A4CF"]);
          res_result_final.push([x, responce[x].per, "<div><span>" + x + "</span><br/><span>Count " + responce[x].count + "</span><br/><span>percent " + responce[x].per + " &nbsp;</span></div>", "stroke-width: 1;stroke-color: black;"]);
        })
        setChartData((prestate) => res_result_final);
      } else {
        setChartData((prestate) => []);
      }
    }
  }

  const options = {
    hAxis: {
      direction: 1,
      slantedText: true,
      slantedTextAngle: 90
      ,
      gridlines: {
        color: 'transparent'
      },
      title: fieldname,
      minValue: 0,
      format: 'short',
    },
    vAxis: {
      gridlines: {
        color: 'transparent'
      },
      title: "Discharge Cycle",
      minValue: 0,
      format: '#\'%\'',
    },
    bar: { groupWidth: "100%" },
    tooltip: { isHtml: true },
    legend: "none",
    isStacked: false,
    series: {
      0: { color: "#83A4CF" },
    },
  };

  useEffect(() => {
    if (apiend === "kratos_drive_second/energyconsuptionbar_whperkm_bus") {
      SetFieldName("kWh/km")
      fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyData)
    }
    else {
      SetFieldName("kWh")
      fetchData({ url: API_URL_MAIN + apiend, body: { filterdata: gloablfilter } }, appyDatakwh)
    }
  }, [gloablfilter, apiend])

  return (
    <>
      <div className=" p-2">
        <div className="v-title">
          <div className="chartHGT">
            <WaterMark />
            {(isLoading) ? <ChartLoader /> : ((chartdata.length == 0) ? <NoData /> : <Chart chartType="ColumnChart" width="100%" height="190px" data={chartdata} options={options} />)}
          </div>
        </div>
      </div>
    </>
  );
}

export default NetEnergyBar;
